import alertService from '@jetbrains/ring-ui/components/alert-service/alert-service'
import classNames from 'classnames'
import {memo, useEffect} from 'react'
import * as React from 'react'

import {useUpdateResults} from '../../../../contexts/update'
import {getBuild} from '../../../../selectors'
import type {ProjectOrBuildTypeNode} from '../../../../types'
import BuildDetails from '../../../common/Builds/BuildDetails/BuildDetails'
import {useBuildsClassName} from '../../../common/Builds/Builds'
import Grid from '../../../common/Grid/Grid'

import {useQueueBuildUpdater} from './useQueueBuildUpdater'

import styles from './QueueBuildDragLayer.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  buildId: number
  wrapped?: boolean
  pathFilter?: ProjectOrBuildTypeNode | null
}

const DEFAULT_TIMEOUT = 10000
const errorMessage =
  'This build is no longer available in the queue. It may already be in progress or may have been cancelled.'

function QueueBuildDragLayer(props: Props) {
  const {buildId, wrapped, pathFilter} = props

  useQueueBuildUpdater(buildId)

  const classes = classNames(styles.content, useBuildsClassName())

  const buildState = useAppSelector(state => getBuild(state, buildId)?.state)
  const updateBuild = useUpdateResults()

  const isQueued = buildState === 'queued'

  useEffect(() => {
    if (!isQueued) {
      alertService.error(errorMessage, DEFAULT_TIMEOUT)
      updateBuild()
    }
  }, [isQueued, updateBuild])

  return isQueued ? (
    <Grid className={classes}>
      <BuildDetails
        buildId={buildId}
        alwaysShowLineBorders
        wrapped={wrapped}
        pathFilter={pathFilter}
      />
    </Grid>
  ) : null
}

export default memo(QueueBuildDragLayer)
